import React, { useContext, useEffect, useState } from "react";
import Header from "../../components/Header";
import Form from "react-bootstrap/Form";
import Sidebar from "../../components/Sidebar";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Completed from "./Completed";
import Pending from "./Pending";
import Loader from "../../components/Loader";
import { ProfileContext } from "../../context/ProfileContext";

function ConsutlationLog() {
  const { pendingConsultation, approvedConsultation, isLoading } = useContext(ProfileContext);
  const [openTab, setOpenTab] = useState("completed")
  const [sortedComplete, setSortedComplete] = useState(approvedConsultation)
  const [sortedPending, setSortedPending] = useState(pendingConsultation)
  const [sortField, setSortField] = useState("updatedAt");
  const [sortDirection, setSortDirection] = useState(-1);

  useEffect(() => {
    handleSort(sortField, sortDirection);
  }, [sortField, sortDirection, openTab, approvedConsultation, pendingConsultation]);

  const handleSort = (field, direction) => {
    const sortMedia = (items) =>
      [...items].sort((a, b) => {
        let valA = field === "full_name"
          ? (a.user_id?.full_name || a.data?.full_name || "").toLowerCase()
          : field === "condition"
            ? (a.condition || a.data?.condition || "").toLowerCase()
            : new Date(a[field] || a.data?.[field]);

        let valB = field === "full_name"
          ? (b.user_id?.full_name || b.data?.full_name || "").toLowerCase()
          : field === "condition"
            ? (b.condition || b.data?.condition || "").toLowerCase()
            : new Date(b[field] || b.data?.[field]);

        if (typeof valA === "string") return valA.localeCompare(valB) * direction;
        if (valA instanceof Date) return (valA - valB) * direction;
        return 0;
      });

    if (openTab === "completed") setSortedComplete(sortMedia(approvedConsultation));
    else setSortedPending(sortMedia(pendingConsultation));
  };


  return (
    <>
      <Loader isLoading={isLoading} />
      <div className="container-fluid">
        <Header />
        <div className="row">
          <Sidebar />
          <div className="col-9 main-dash-left">
            <section className="back-dashboard-sec comn-dashboard-page">
              <div className="notifi-list d-flex">
                <div>
                  <h6 className="comm_page_heading">Consultation Logs</h6>
                  <p className="comm_page_sub_heading">
                    View a detailed log of all recent consultations, including
                    patient interactions, AI-generated assessments, and
                    recommended follow-up actions.
                  </p>
                </div>
                <div className="d-flex sort_by_filter_outer">
                  <div className="head">Sort By:</div>
                  <div className="dropdown_inner_list_select">
                    <Form.Select value={sortField}
                      onChange={(e) => {
                        const selectedField = e.target.value;
                        if (selectedField === sortField) { setSortDirection(sortDirection * -1) }
                        else { setSortField(selectedField); setSortDirection(1) }
                      }}
                    >
                      <option value="createdAt">Date</option>
                      <option value="full_name">Patient Name</option>
                      <option value="condition">Condition</option>
                    </Form.Select>
                  </div>
                </div>
              </div>
              <div className="upper-mian-tabs-comn">
                <Tabs onSelect={(k) => setOpenTab(k)} activeKey={openTab}>
                  <Tab eventKey="completed"
                    title={
                      <div className="custom-tab-title">
                        <span>Completed</span> <p className="tab_count">{approvedConsultation?.length}</p>
                      </div>
                    }
                  >
                    <Completed data={sortedComplete} />
                  </Tab>
                  <Tab eventKey="pending"
                    title={
                      <div className="custom-tab-title">
                        <span>Pending</span> <p className="tab_count">{pendingConsultation?.length}</p>
                      </div>
                    }>
                    <Pending data={sortedPending} />
                  </Tab>
                </Tabs>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default ConsutlationLog;
